import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  currencyStyle: (/* props */) => ({
    // fontSize: props.size,
  }),
}))

export default useStyles
